import { Observable } from 'rxjs/Observable';
import { LemsarApiClient } from '@lemsar/api/client';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Injectable } from '@angular/core';
import { Program } from '@lemsar/institution/domains/model/program';
import { UI } from '@shared/models/ui';
import { StoreData } from '@shared/module/common/model/store-data';
import { Collection } from '@lemsar/common/domains/interface/collection';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    20/06/2018
 */
@Injectable()
export class ProgramService {
    private _ui: StoreData<UI>;

    public constructor(private api: LemsarApiClient) {
        this._ui = new StoreData<UI>(new UI());
    }

    public get ui$(): Observable<UI> {
        return this._ui.stream$;
    }

    public get ui(): UI {
        return this._ui.value;
    }

    public fetchInstitutionPrograms(id: string, params?: any): Observable<Collection<Program>> {
        const queryParams = !params
            ? { page: 1, limit: 15 }
            : { page: params.page || 1, limit: params.limit || 15, group: params.group || [] };

        return this.api.get<any>('institutions/' + id + '/programs', queryParams).pipe(ResponseTransformer.toCollection(Program));
    }

    public fetchInstitutionProgramsNoPaging(id: string, params?: any): Observable<Collection<Program>> {
        const queryParams = !params ? {} : { group: params.group || [] };

        return this.api.get<any>('institutions/' + id + '/programs', queryParams).pipe(ResponseTransformer.toCollection(Program));
    }

    public fetchInstitutionProgramById(institutionId: string, programId: string): Observable<Program> {
        return this.api
            .get<any>('institutions/' + institutionId + '/programs/' + programId)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Program));
    }

    public createInstitutionProgram(id: string, value: Program): Observable<Program> {
        return this.api
            .post<any>('institutions/' + id + '/programs', value)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Program));
    }

    public updateInstitutionProgram(institutionId: string, programId: string, value: any): Observable<Program> {
        return this.api
            .patch<any>('institutions/' + institutionId + '/programs/' + programId, value)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Program));
    }

    public deleteInstitutionProgram(institutionId: string, trainingId: string): Observable<Program> {
        return this.api
            .delete<any>('institutions/' + institutionId + '/programs/' + trainingId)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Program));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/services/program.service.ts